/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTOClaimList from './DTOClaimList';
import ClaimListPresenter from './ClaimListPresenter';
import { useAppSelector } from '../../../../infra/hooks';
import { useTranslation } from 'react-i18next';

function ClaimListController() {
  const [allEmpClaims, setAllEmpClaims] = useState([]);
  const isLoading = useAppSelector(
    (state) => state.claimListSlice.claimListLoader,
  );

  const { t } = useTranslation();

  function callBackFunc(data: any) {
    setAllEmpClaims(data);
  }

  return (
    <>
      <DTOClaimList setEmpClaimData={callBackFunc} />
      <ClaimListPresenter
        empClaims={allEmpClaims}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default ClaimListController;
